<!-- display-mobile-10 preview — a full-screen interstitial: the ad takes the
     whole phone, so there is no publisher page or browser bar behind it. -->
<app-mobile-frame>
  <!-- START: Real ad -->
  <div class="da-interstitial d-flex flex-column">
    <a [href]="data.url" target="_blank" rel="noopener noreferrer" class="da-creative">
      <img *ngIf="creativeImage" class="da-creative-image" [src]="creativeImage" alt="" />
      <div *ngIf="!creativeImage" class="da-creative-image creative-missing">{{ missingDimensionLabel }}</div>

      <span class="da-adchoices d-flex align-items-center justify-content-center">
        <i class="bi bi-info-circle"></i>
      </span>
    </a>

    <div class="da-copy">
      <a [href]="data.url" target="_blank" rel="noopener noreferrer" class="da-headline">
        {{ data.headlines[0] || "Your headline appears here" }}
      </a>

      <div class="da-desc">
        {{ data.descriptions[0] || "Your description appears here" }}
      </div>

      <div class="da-advertiser">Valamar</div>
    </div>

    <div class="da-actions d-flex flex-row justify-content-center">
      <!-- The interstitial's own dismiss control rather than authored copy, so
           it is a plain label and not a link. -->
      <span class="da-dismiss">Zatvori</span>

      <a [href]="data.url" target="_blank" rel="noopener noreferrer" class="da-cta">{{ data.ctaText || "Your call to action" }}</a>
    </div>
  </div>
  <!-- END: Real ad -->
</app-mobile-frame>
